import React from "react";
const Chronic = require('../img/Chronic.jpg')
const Illness = require('../img/AcuteIllness.jpg')
const Addiction = require('../img/Addiction.jpg')
const Counselling = require('../img/Counselling.jpg')
const Fitness = require('../img/Fitness.jpg')
const Checkup = require('../img/HealthCheckup.jpg')
const Procedure = require('../img/Procedure.jpg')
const WoundCare = require('../img/WoundCare.jpg')

export default function Services() {
    const servicesData = [
        {
            title: "Chronic Diseases",
            desc: "Treatment of common diseases like diabetes, hypertension, hypothyroidism, high cholesterol.",
            img: Chronic
        },
        {
            title: "Acute medical illnesses",
            desc: "Infectious diseases (cough, cold, fever), allergies, muscle pain, joint pains, diarrhoea, stomach pain, vomiting.",
            img: Illness
        },
        {
            title: "Wound care",
            desc: "Including wound suturing and dressing.",
            img: WoundCare
        },
        {
            title: "General health checkup",
            desc: "Every individual's healthcare need is different which requires personalised approach.",
            img: Checkup
        },
        {
            title: "Procedures",
            desc: "Including feeding tube, foley's catheter and IV cannula placement.",
            img: Procedure
        },
        {
            title: "Counselling",
            desc: "One on One child, career, professional excellence, marriage and personal development counselling.",
            img: Counselling
        },
        {
            title: "Guidance",
            desc: "One on One disease prevention, health preservation, weight loss and physique building guidance.",
            img: Fitness
        },
        {
            title: "Addictions",
            desc: "Smoking, tobacco, drugs and alcohol rehabilitation.",
            img: Addiction
        },
    ]
	return (
		<div id="services" style={{padding: "5% 0"}}>
            <p className="services-heading">Our Services</p>
            <hr className="underline"/>
            <div className="services-container">
                {servicesData.map((data, id) => {
                    return (
                        <div className="services-card" key={id}>
                            <img src={data.img} alt="" className="services-img" />
                            <h2 className="services-title">{data.title}</h2>
                            <p className="services-desc">{data.desc}</p>
                        </div>
                    )
                })}
            </div>
        </div>
	);
}
